/* eslint-disable no-console */
import { RECENT_TAG_OR_COMMIT } from 'shared/config'

export const displayDeployedTagOrCommit = () => {
  if (import.meta.env.DEV) return

  if (RECENT_TAG_OR_COMMIT) {
    console.log(`Build version: ${RECENT_TAG_OR_COMMIT}`)
  } else {
    console.warn('Build version is not provided')
  }
}
